<template>
  <b-row>
    <b-col cols="12">
      <search-view :click-search="getInstallations"/>
    </b-col>
    <b-col cols="12">
      <b-card title="">
        <b-overlay
            variant="white"
            :show="showLoading"
            spinner-variant="primary"
            blur="0"
            opacity=".75"
            rounded="sm"
        >
          <div class="ml-1 mb-2">
            <b-row>
              <b-col cols="12" md="9"
                     class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
              >
                <label>Mostrar</label>
                <v-select
                    v-model="pageLength"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="['3','5','10','20']"
                    :clearable="false"
                    class="per-page-selector d-inline-block mx-50"
                    @input="changeLength"
                />
                <button class="btn btn-primary" @click="exportToExcel">Exportar a Excel</button>
              </b-col>
            </b-row>
          </div>

          <b-table
              ref="refUserListTable"
              class="position-relative table-size-list"
              :items="children_installations"
              responsive
              sticky-header
              striped
              :fields="columns"
              primary-key="id"
              show-empty
              empty-text="No hay registros"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              @head-clicked="handleHeaderClick"
          >
            <template #cell(masterInstallation.client_cif)="data">
              {{ data.item.master_installation.client_cif }}
            </template>

            <template #cell(gei_code)="data">
              {{ data.item.gei_code }}
            </template>

            <template #cell(active_installation)="data">
              <b-badge :variant="data.item.active_installation === 1 ? 'success' : 'danger'">
                {{ data.item.active_installation === 1 ? 'Si' : 'No' }}
              </b-badge>
            </template>

            <template #cell(draft)="data">
              <b-badge :variant="data.item.draft === 1 ? 'success' : 'danger'">
                {{ data.item.draft === 1 ? 'Si' : 'No' }}
              </b-badge>
            </template>

            <template #cell(masterInstallation.client)="data">
              {{ data.item.master_installation.client }}
            </template>

            <template #cell(masterInstallation.responsible_id)="data">
              {{ data.item.master_installation.responsible ? data.item.master_installation.responsible.name : null }}
            </template>

            <template #cell(masterInstallation.proceeding_code)="data">
              {{ data.item.master_installation.proceeding_code ? data.item.master_installation.proceeding_code : null }}
            </template>

            <template #cell(expedient_prl)="data">
              {{ data.item.expedient_prl ? data.item.expedient_prl : null }}
            </template>

            <template #cell(masterInstallation.figure_id)="data">
              {{ figures[data.item.master_installation.figure_id - 1] ? figures[data.item.master_installation.figure_id - 1].name : null }}
            </template>

            <template #cell(country)="data">
              {{ data.item.master_installation.province_country
                ? data.item.master_installation.province_country.country
                : null }}
            </template>

            <template #cell(masterInstallation.address)="data">
              {{ data.item.master_installation.address }}
            </template>

            <template #cell(masterInstallation.installation_type_id)="data">
              {{ data.item.typology ? data.item.typology.name : null }}
            </template>

            <template #cell(province_country)="data">
              {{ data.item.master_installation.province_country
                ? data.item.master_installation.province_country.province
                : null }}
            </template>

            <template #cell(autonomous_community)="data">
              {{ data.item.autonomous_community ? data.item.autonomous_community : null }}
            </template>


            <template #cell(masterInstallation.city)="data">
              {{ data.item.master_installation.city }}
            </template>

            <template #cell(installation_type)="data">
              {{ data.item.installation_type ? data.item.installation_type.type : null }}
            </template>

            <template #cell(start_date)="data">
              {{ data.item.start_date ? helpers.formatDate(data.item.start_date) : null }}
            </template>

            <template #cell(end_date)="data">
              {{ data.item.end_date ? helpers.formatDate(data.item.end_date) : null }}
            </template>

            <template #cell(period_description)="data">
              {{ data.item.period_description }}
            </template>

            <template #cell(providerContractEE.provider_id)="data">
              {{ data.item.provider_contract_e_e[0] ?
                (data.item.provider_contract_e_e[0].provider ? data.item.provider_contract_e_e[0].provider.provider : null)
                : null }}
            </template>

            <template #cell(level_1)="data">
              {{ data.item.master_installation.level_1 ? data.item.master_installation.level_1.name : null }}
            </template>

            <template #cell(level_2)="data">
              {{ data.item.master_installation.level_2 ? data.item.master_installation.level_2.name : null }}
            </template>

            <template #cell(level_3)="data">
              {{ data.item.master_installation.level_3 ? data.item.master_installation.level_3.name : null }}
            </template>

            <template #cell(level_4)="data">
              {{ data.item.master_installation.level_4 ? data.item.master_installation.level_4.name : null }}
            </template>

            <template #cell(masterInstallation.territory_opsva_id)="data">
              {{ data.item.master_installation.opsva_territory ? data.item.master_installation.opsva_territory.name : null }}
            </template>

            <template #cell(masterInstallation.client_type_id)="data">
              {{ data.item.master_installation.client_type ? data.item.master_installation.client_type.type : null }}
            </template>

            <template #cell(client_contact_person)="data">
              {{ data.item.master_installation.client_contact_person }}
            </template>

            <template #cell(masterInstallation.client_phone)="data">
              {{ data.item.master_installation.client_phone }}
            </template>

            <template #cell(masterInstallation.client_email)="data">
              {{ data.item.master_installation.client_email }}
            </template>

            <template #cell(masterInstallation.company_id)="data">
              {{ data.item.master_installation.company ? data.item.master_installation.company.name : null }}
            </template>
          </b-table>
          <div class="mx-2 mb-2">
            <b-row>
              <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-start"
              >
                <span class="text-muted">Mostrando {{ pageLength }} de {{ totalRecords }} Instalaciones</span>
              </b-col>

              <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-end"
              >
                <b-pagination
                    :value="1"
                    :total-rows="totalRecords"
                    :per-page="pageLength"
                    first-number
                    last-number
                    align="right"
                    prev-class="prev-item"
                    next-class="next-item"
                    class="mt-1 mb-0"
                    @input="changePage"
                >
                  <template #prev-text>
                    <feather-icon
                        icon="ChevronLeftIcon"
                        size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                        icon="ChevronRightIcon"
                        size="18"
                    />
                  </template>
                </b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-overlay>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {BRow, BCol, BTable, BCard, BOverlay, BBadge, BPagination} from 'bootstrap-vue'
import {mapState} from "vuex"
import helpers from "@/resources/helpers/helpers"
import ExcelJS from "exceljs"
import SearchView from "@/views/gei/dashboard_metrics/list/components/childrenInstallationsSearchView.vue"
import vSelect from "vue-select"

export default {
  name: "ListView",
  components: {
    BPagination,
    vSelect,
    SearchView,
    BRow,
    BCol,
    BTable,
    BCard,
    BOverlay,
    BBadge,
  },
  data() {
    return {
      columns: [
        {key: 'masterInstallation.client_cif', label: 'CIF', sortable: true, class: 'sortable-column'},
        {key: 'gei_code', label: 'CODIGO_GEI_1', sortable: true, class: 'sortable-column'},
        {key: 'active_installation', label: 'Instalación Activa', sortable: true, class: 'sortable-column'},
        {key: 'draft', label: 'Instalación Borrador', sortable: true, class: 'sortable-column'},
        {key: 'masterInstallation.client', label: 'Cliente', sortable: true, class: 'sortable-column'},
        {key: 'masterInstallation.responsible_id', label: 'Responsable', sortable: true, class: 'sortable-column'},
        {key: 'masterInstallation.proceeding_code', label: 'Expediente OR', sortable: true, class: 'sortable-column'},
        {key: 'expedient_prl', label: 'Expediente PRL', sortable: true, class: 'sortable-column'},
        {key: 'masterInstallation.figure_id', label: 'Figura RD171', sortable: true, class: 'sortable-column'},
        {key: 'country', label: 'Pais', sortable: true, class: 'sortable-column'},
        {key: 'masterInstallation.address', label: 'Dirección Gei', sortable: true, class: 'sortable-column'},
        {key: 'autonomous_community', label: 'Comunidad Autónoma', sortable: true, class: 'sortable-column'},
        {key: 'province_country', label: 'Provincia/Zona', sortable: true, class: 'sortable-column'},
        {key: 'masterInstallation.city', label: 'Población', sortable: true, class: 'sortable-column'},
        {key: 'masterInstallation.installation_type_id', label: 'Tipologia', sortable: true, class: 'sortable-column'},
        {key: 'installation_type', label: 'Tipo de instalacion', sortable: true, class: 'sortable-column'},
        {key: 'start_date', label: 'Fecha inicio explotación', sortable: true, class: 'sortable-column'},
        {key: 'end_date', label: 'Fecha fin explotación', sortable: true, class: 'sortable-column'},
        {key: 'period_description', label: 'Duración', sortable: true, class: 'sortable-column'},
        {key: 'maintainer', label: 'Mantenedor', sortable: false},
        {key: 'masterInstallation.territory_opsva_id', label: 'Territorio_OPSVA', sortable: true, class: 'sortable-column'},
        {key: 'masterInstallation.client_type_id', label: 'Tipo cliente', sortable: true, class: 'sortable-column'},
        {key: 'masterInstallation.client_contact_person', label: 'Contacto', sortable: true, class: 'sortable-column'},
        {key: 'masterInstallation.client_phone', label: 'Teléfono', sortable: true, class: 'sortable-column'},
        {key: 'masterInstallation.client_email', label: 'Email', sortable: true, class: 'sortable-column'},
        {key: 'masterInstallation.company_id', label: 'Empresa', sortable: true, class: 'sortable-column'},
      ],
      showLoading: false,
      helpers,

      figures: [
        { 'id' : 1, 'name': 'MANTENEDOR' },
        { 'id' : 2, 'name': 'PROPIETARIO' },
        { 'id' : 3, 'name': 'TITULAR' }
      ],
      page: 1,
      pageLength: 10,
      totalRecords: 10,
      sortBy: null,
      sortDesc: false,
      field: null,
    }
  },
  computed: {
    ...mapState('childrenInstallation', ['children_installations','search']),
  },
  created() {
    this.getInstallations()
  },
  methods: {
    can(permission) {
      return this.$store.getters.can(permission)
    },
    formatDate(date) {
      const dateFormated = new Date(date)

      return dateFormated.toLocaleDateString("es-ES")
    },
    getInstallations() {
      this.showLoading = true

      let filteredSearch = JSON.parse(JSON.stringify(this.search))

      if (this.search.master_installation.province) {
        if (filteredSearch.master_installation) {
          delete filteredSearch.master_installation.country
        }
      }

      if (!filteredSearch.master_installation.companies || filteredSearch.master_installation.companies.length < 1){
        const userCompanies = this.$store.state.AppActiveUser.companies
        filteredSearch.master_installation.companies = userCompanies.map(company => company.id)
      }

      this.$store.dispatch('childrenInstallation/listAllChildrenInstallations', {
        relations: ['masterInstallation', 'masterInstallation.company', 'masterInstallation.responsible',
          'masterInstallation.opsvaTerritory', 'masterInstallation.provinceCountry',
          'masterInstallation.clientType', 'providerContractEE', 'typology', 'documentOrder'],
        per_page: this.pageLength,
        page: this.page,
        filter: filteredSearch,
        order_filter: this.sortDesc ? 'desc' : 'asc',
        column_order_filter: this.field,
      })
          .then(response => {
            this.showLoading = false
            this.totalRecords = response.total_records

          })
          .catch(error => {
            this.showLoading = false
            console.log(error)
          })
    },
    async fetchAllInstallations() {
      try {
        let filteredSearch = JSON.parse(JSON.stringify(this.search))

        if (this.search.master_installation.province) {
          if (filteredSearch.master_installation) {
            delete filteredSearch.master_installation.country
          }
        }

        if (!filteredSearch.master_installation.companies || filteredSearch.master_installation.companies.length < 1){
          const userCompanies = this.$store.state.AppActiveUser.companies
          filteredSearch.master_installation.companies = userCompanies.map(company => company.id)
        }

        const response = await this.$store.dispatch('childrenInstallation/listAllChildrenInstallations', {
          relations: ['masterInstallation', 'masterInstallation.company', 'masterInstallation.responsible',
            'masterInstallation.opsvaTerritory', 'masterInstallation.provinceCountry',
            'masterInstallation.clientType', 'providerContractEE', 'typology', 'documentOrder'],
          per_page: this.totalRecords,
          page: this.page,
          filter: filteredSearch,
          order_filter: this.sortDesc ? 'desc' : 'asc',
          column_order_filter: this.field,
        })

        return response.data
      } catch (error) {
        console.error('Error al obtener todos los registros:', error)
        return []
      }
    },
    async exportToExcel() {
      const allInstallations = await this.fetchAllInstallations()

      this.changeLength(this.length)

      const workbook = new ExcelJS.Workbook()
      const worksheet = workbook.addWorksheet('InstalacionesHijasGEI')

      const headers = [
        'CIF',
        'CODIGO_GEI_1',
        'InstalaciónActiva',
        'InstalaciónBorrador',
        'Cliente',
        'Expediente OR',
        'Expediente PRL',
        'Responsable',
        'Figura RD171',
        'Pais',
        'Dirección Gei',
        'Provincia/Zona',
        'Población',
        'Comunidad Autónoma',
        'Tipología',
        'Tipo de instalacion',
        'Fecha inicio explotación',
        'Fecha fin explotación',
        'Duración',
        'Mantenedor',
        'Territorio_OPSVA',
        'Tipo cliente',
        'Contacto',
        'Teléfono',
        'Email',
        'Empresa'
      ]

      worksheet.addRow(headers)

      allInstallations.forEach(detail => {
        worksheet.addRow([
          detail.master_installation.client_cif,
          detail.gei_code,
          detail.active_installation === 1 ? 'Si' : 'No',
          detail.draft === 1 ? 'Si' : 'No',
          detail.master_installation.client,
          detail.master_installation.proceeding_code ? detail.master_installation.proceeding_code : null,
          detail.expedient_prl ? detail.expedient_prl : null,
          detail.master_installation.responsible ? detail.master_installation.responsible.name : null,
          this.figures[detail.master_installation.figure_id - 1] ? this.figures[detail.master_installation.figure_id - 1].name : null,
          detail.master_installation.province_country ? detail.master_installation.province_country.country : null,
          detail.master_installation.address,
          detail.master_installation.province_country ? detail.master_installation.province_country.province : null,
          detail.master_installation.city,
          detail.autonomous_community ? detail.autonomous_community : null,
          detail.typology ? detail.typology.name : null,
          detail.installation_type ? detail.installation_type.type : null,
          detail.start_date ? helpers.formatDate(detail.start_date) : null,
          detail.end_date ? helpers.formatDate(detail.end_date) : null,
          detail.period_description,
          detail.provider_contract_e_e[0] ?
              (detail.provider_contract_e_e[0].provider ? detail.provider_contract_e_e[0].provider.provider : null)
              : null,
          detail.master_installation.opsva_territory ? detail.master_installation.opsva_territory.name : null,
          detail.master_installation.client_type ? detail.master_installation.client_type.type : null,
          detail.master_installation.client_contact_person,
          detail.master_installation.client_phone,
          detail.master_installation.client_email,
          detail.master_installation.company ? detail.master_installation.company.name : null
        ])
      })

      // Generar el archivo Excel
      const buffer = await workbook.xlsx.writeBuffer()

      // Crear un Blob para la descarga
      const blob = new Blob([buffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})

      // Crear una URL para el Blob
      const url = window.URL.createObjectURL(blob)

      // Crear un enlace de descarga y hacer clic en él
      const a = document.createElement('a')
      a.href = url
      a.download = 'instalacionesHijasGEI.xlsx'
      a.click()

      // Liberar recursos
      window.URL.revokeObjectURL(url)
    },
    changePage(page) {
      this.page = page
      this.getInstallations()
    },
    changeLength(length) {
      this.length = length
      this.getInstallations()
    },
    handleHeaderClick(field) {

      if (this.sortBy === field) {
        this.sortDesc = !this.sortDesc
      } else {
        this.sortBy = field
        this.sortDesc = false
      }

      this.showLoading = true

      let filteredSearch = JSON.parse(JSON.stringify(this.search))

      if (this.search.master_installation.province) {
        if (filteredSearch.master_installation) {
          delete filteredSearch.master_installation.country
        }
      }

      if (field === 'province_country') {
        field = 'masterInstallation.province_country_id'
      }else if (field === 'country') {
        field = 'masterInstallation.province_country_id'
      }

      this.field = field

      this.$store.dispatch('childrenInstallation/listAllChildrenInstallations', {
        relations: ['masterInstallation', 'masterInstallation.company', 'masterInstallation.responsible',
          'masterInstallation.opsvaTerritory', 'masterInstallation.provinceCountry',
          'masterInstallation.clientType', 'providerContractEE', 'typology', 'documentOrder'],
        per_page: this.pageLength,
        page: this.page,
        filter: filteredSearch,
        order_filter: this.sortDesc ? 'desc' : 'asc',
        column_order_filter: field,
      })
          .then(response => {
            this.showLoading = false
            this.totalRecords = response.total_records

          })
          .catch(error => {
            this.showLoading = false
            console.log(error)
          })

    },
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.sortable-column {
  cursor: pointer;
}

.sortable-header {
  display: flex;
  align-items: center;
  gap: 5px;
}
</style>